import { Action } from '@ngrx/store';

import {
  StockProductListResponse,
  StockProductSearchCriteria,
  StockTransferItem
} from '../../models/stock-transfer-request.model';

export enum StockProductActionTypes {
  STOCK_PRODUCT_LIST_REQUEST = '[Stock Product] Stock Product List Request',
  STOCK_PRODUCT_LIST_RESPONSE = '[Stock Product] Stock Product List Response',
  STOCK_PRODUCT_LIST_RESET = '[Stock Product] Stock Product List Reset',
  STOCK_PRODUCT_UPDATE_ITEM = '[Stock Product] Stock Product Update Item'
}

export class StockProductListRequestAction implements Action {
  readonly type = StockProductActionTypes.STOCK_PRODUCT_LIST_REQUEST;

  constructor(public payload: StockProductSearchCriteria) {}
}

export class StockProductListResponseAction implements Action {
  readonly type = StockProductActionTypes.STOCK_PRODUCT_LIST_RESPONSE;

  constructor(public payload: StockProductListResponse) {}
}

export class StockProductListResetAction implements Action {
  readonly type = StockProductActionTypes.STOCK_PRODUCT_LIST_RESET;

  constructor() {}
}

export class StockProductUpdateItem implements Action {
  readonly type = StockProductActionTypes.STOCK_PRODUCT_UPDATE_ITEM;

  constructor(public payload: StockTransferItem) {}
}

export type StockProductActions =
  | StockProductListRequestAction
  | StockProductListResponseAction
  | StockProductListResetAction
  | StockProductUpdateItem;
